import { MenuItem, styled } from '@mui/material';

export const SessionMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  backgroundColor: theme.palette.action.hover,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  cursor: 'default',
  '&.MuiMenuItem-root:not(:last-child)': {
    marginBottom: theme.spacing(1.5),
  },
}));

export const SessionItemContent = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 1.5, 1, 1.5),
  gap: theme.spacing(0.5),
  width: '100%',
}));

export const StyledNoteItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: theme.spacing(0.5),
  gap: theme.spacing(3),
  cursor: 'pointer',
}));
